import http from "./httpService";

export function getPeriodosEvaActivos() {
    const apiEndPointLC = "/PeriodosEvaluativos/activos";

    return http.get(apiEndPointLC);
}